import script from "./GraphButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./GraphButtons.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky});
